import { useState } from 'react';

import type { PageScrollPosition } from './context';

export function usePageScrollPositionState(): PageScrollPosition {
	const [info, setInfo] = useState<PageScrollPosition>({
		afterDescription: undefined,
		setAfterDescription: (afterDescription: boolean) => {
			setInfo((currentInfo) =>
				afterDescription === currentInfo.afterDescription ? currentInfo : { ...currentInfo, afterDescription },
			);
		},
		// Default to true to avoid the value being undefined until the waypoint is triggered
		beforeSuggestedPetitions: true,
		setBeforeSuggestedPetitions: (beforeSuggestedPetitions: boolean) => {
			setInfo((currentInfo) =>
				beforeSuggestedPetitions === currentInfo.beforeSuggestedPetitions
					? currentInfo
					: { ...currentInfo, beforeSuggestedPetitions },
			);
		},
		afterMedia: undefined,
		setAfterMedia: (afterMedia: boolean) => {
			setInfo((currentInfo) => (afterMedia === currentInfo.afterMedia ? currentInfo : { ...currentInfo, afterMedia }));
		},
		afterMobileActionButton: undefined,
		setAfterMobileActionButton: (afterMobileActionButton: boolean) => {
			setInfo((currentInfo) =>
				afterMobileActionButton === currentInfo.afterMobileActionButton
					? currentInfo
					: { ...currentInfo, afterMobileActionButton },
			);
		},
	});
	return info;
}
